import { UserInfo } from '../user';

export enum NextOfKinRelationType {
    family = 'family',
    external = 'external',
}

export interface NextOfKin extends UserInfo {
    profile: NextOfKinProfile;
    email: string;
    /** The phone on the relative's profile; may not be confirmed for login. */
    phoneNumber?: string;
    organizationId: string;
    relation: NextOfKinRelationType;
    isMainContact?: boolean;
    isGuardian?: boolean;
    disableManagingRelatives?: boolean;
    followers?: { consumerIds?: string[] };
}

interface NextOfKinProfile {
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    avatar?: string;
}
